
import { useState } from "react";
import { VisitActive, VisitPassive } from "../../../../assets/icons";
import { api } from "../../../../utils/api";
import { LoginHelper } from "../../../../utils/LoginHelper";

export default function Visit({ doctorId, dayId, visit, onToggleVisitReserve }) {
	const [isReserve, setIsReserve] = useState(visit.is_reserve);
	const [isProfileOwner, setIsProfileOwner] = useState(visit.is_profile_owner);
	const [isLoading, setIsLoading] = useState(false);

	const toggle = () => {
		if (isLoading) return;
		setIsLoading(true);
		api.visitToggleVisitReserve({
			token: LoginHelper.getToken(),
			doctor_profile_id: doctorId,
			start_datetime: visit.start_datetime,
		}).then((res) => {
			setIsLoading(false);
			setIsReserve(!isReserve);
			setIsProfileOwner(!isProfileOwner);
			onToggleVisitReserve(dayId, visit.start_datetime, !isReserve, !isProfileOwner);
		}).catch((err) => {
			setIsLoading(false);
			console.log(err);
		});
	}

	return (
		<div className={`${visit.is_active & isProfileOwner ? 'bg-[#CDE7FF]' : ''} 
						${visit.is_active && !isReserve ? 'bg-[#EBEFF3]' : ''}
						${!visit.is_active || (isReserve && !isProfileOwner) ? 'border-[#EEEEEE] border-[1px]' : ''}
						rounded-[10px] p-[10px] cursor-pointer`} onClick={() => toggle()}>
			<div></div>
			<div className="flex flex-row justify-center items-center">
				<div className="font-Vazir-400 text-[16px]">{visit.start_time}</div>
				<div className="px-[5px]">-</div>
				<div className="font-Vazir-400 text-[16px]">{visit.finish_time}</div>
			</div>
			<div className="spacer p-[5px]"></div>
			<div>
				{visit.is_active ? (
					<>
						{isReserve ? (
							<>
								{isProfileOwner ? (
									<div className="flex flex-row justify-between items-center bg-white h-[20px] rounded-[10px] px-[10px] py-[5px]">
										<div className="flex flex-row justify-center items-center w-[25px] h-[25px] rounded-[20px] bg-[#276AA6]">
											<VisitActive />
										</div>
										<div className="spacer p-[5px]"></div>
										<div className="font-Vazir-400 text-[12px] text-[#aaaaaa]">
											رزرو
										</div>
									</div>
								) : (
									<>
										<div className="flex flex-row justify-center items-center bg-white h-[20px] rounded-[10px] px-[10px] py-[5px]">
											<div className="font-Vazir-400 text-[12px] text-[#aaaaaa]">
												رزرو شده
											</div>
										</div>
									</>
								)}
							</>
						) : (
							<div className="flex flex-row justify-between items-center bg-white h-[20px] rounded-[10px] px-[10px] py-[5px]">
								<div className="font-Vazir-400 text-[12px] text-[#aaaaaa]">
									خالی
								</div>
								<div className="spacer p-[5px]"></div>
								<div className="flex flex-row justify-center items-center w-[25px] h-[25px] rounded-[20px] bg-[#969BA1]">
									<VisitPassive />
								</div>
							</div>
						)}
					</>
				) : (
					<>
						<div className="flex flex-row justify-center items-center bg-white h-[20px] rounded-[10px] px-[10px] py-[5px]">
							<div className="font-Vazir-400 text-[12px] text-[#aaaaaa]">
								غیرقابل رزرو
							</div>
						</div>
					</>
				)}
			</div>
			<div className="spacer p-[5px]"></div>
			<div>
				{isProfileOwner ? (
					<div className="font-Vazir-400 text-[12px] text-black text-center">رزرو شما</div>
				) : (
					<></>
				)}
			</div>
		</div>
	)
}
